import patternValidators from 'helpers/validators/pattern-validators';
import PropTypes from 'prop-types';

import { Input } from 'components/FormComponents';

export const Website = ({
  name,
  label,
  placeholder,
  disabled,
  defaultValue,
  register = () => {},
  validators = {},
  className,
  inputProps = {},
  error = '',
  noErrorMessage = false,
}) => {
  // Combine default website validation with any validators passed from parent
  const combinedValidators = {
    ...patternValidators.website,
    ...validators,
  };

  return (
    <Input
      name={name}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      defaultValue={defaultValue}
      register={register}
      validators={combinedValidators}
      error={error}
      noErrorMessage={noErrorMessage}
      noPadding
      {...inputProps}
    />
  );
};

Website.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  autoComplete: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  register: PropTypes.func,
  required: PropTypes.bool,
  inputProps: PropTypes.object,
  error: PropTypes.string,
  noErrorMessage: PropTypes.bool,
};
